import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useDialog } from '../../../shared/context';
import { TrainingDialog } from '../../Dialog/TrainingDialog';
import AxiosInstance from '../../../server/AxioInstance';

const BodyTraining = () => {
  const { isDialogOpen, openDialog, closeDialog, dialogData } = useDialog('trainingDialog');
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [rows, setRows] = useState([]);

  const handleCloseDialog = () => closeDialog();
  const handleConfirmAction = handleCloseDialog;
  const handleCancelAction = handleCloseDialog;
  const handleCreateTraining = openDialog;

  const fetchCoach = useCallback(async () => {
    const result = await AxiosInstance.post(`/training/get-coach-view`, {
      user_login: localStorage.getItem('@gedy:user'),
    });
    setButtonDisabled(result.data);
  }, []);

  const fetchTrainingTable = useCallback(async () => {
    try {
      const result = await AxiosInstance.post(`/training/get-training-table`, {
        user_login: localStorage.getItem('@gedy:user'),
      });
      setRows(result.data);
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  useEffect(() => {
    fetchCoach();
    fetchTrainingTable();
  }, [fetchCoach, fetchTrainingTable]);

  function Row({ row }) {
    console.log('row', row)
    const [open, setOpen] = useState(false);
    const [funcionarios, setFuncionarios] = useState([]);

    const getFuncionarios = useCallback(async (item) => {
      const response = await AxiosInstance.post('/training/get-user-treainings', item);
      setFuncionarios(response.data);
    }, []);

    const handleConfirmPresence = async (item, linha, who = 'user') => {
      const temp = { ...item, who };
      try {
        await AxiosInstance.post('/training/confirm-presence', temp);
        getFuncionarios(linha);
      } catch (error) {
        console.error(error);
      }
    };

    const dataTraining = (item) => {
      const dateString = item.dt_training;
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('/');
      const [hour, minute, second] = timePart.split(':');
      const date = new Date();
      const formattedDate = new Date(`${year}-${month}-${day} ${hour}:${minute}:${second}`);
      return formattedDate <= date;
    };

    const handleTrainingEdit = (row) => {
      const temp = { ...row, type: 'edit', }
      handleCreateTraining(temp);
    };

    return (
      <>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => [setOpen(!open), getFuncionarios(row)]}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row" align="center">
            {row.id}
          </TableCell>
          <TableCell align="right">{row.title}</TableCell>
          <TableCell align="right">{row.description}</TableCell>
          <TableCell align="center">{row.dt_training}</TableCell>
          <TableCell align="left">{row.instructors_name}</TableCell>
          <TableCell align="center">
            <Button
              disabled={localStorage.getItem('@gedy:user') !== row.user_login}
              onClick={() => handleTrainingEdit(row)}
              variant="contained"
              color="warning">
              editar treinamento
            </Button>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Funcionários que farão o treinamento.
                </Typography>
                {funcionarios?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {item.user_name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item.status}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {dataTraining(row) ? (
                        item.user_login === localStorage.getItem('@gedy:user') &&
                        item.preview === false ? (
                          <Button
                            onClick={() => handleConfirmPresence(item, row)}
                            variant="contained"
                          >
                            Confirmar presença
                          </Button>
                        ) : item.user_login_training === localStorage.getItem('@gedy:user') &&
                          item.viewing_confirmation === false ? (
                          <Button
                            onClick={() => handleConfirmPresence(item, row, 'instrutor')}
                            variant="contained"
                          >
                            Confirmar presença
                          </Button>
                        ) : null
                      ) : null}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <a href={row.link} target="_blank" rel="noopener noreferrer">
                        Link questionário
                      </a>
                    </TableCell>
                  </TableRow>
                ))}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <>
      <Box>
        {isDialogOpen() && (
          <TrainingDialog
            handleClose={handleCloseDialog}
            handleConfirm={handleConfirmAction}
            handleCancel={handleCancelAction}
            dialogData={dialogData}
            fetchTrainingTable={fetchTrainingTable}
          />
        )}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <Button
              onClick={() => handleCreateTraining({ type: 'create', })}
              fullWidth
              variant="contained"
              color="secondary"
              disabled={isButtonDisabled}
            >
              criar treinamento
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box mt={5}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell align="center">Num. Treinamento</TableCell>
                    <TableCell align="right">Título</TableCell>
                    <TableCell align="right">Motivo</TableCell>
                    <TableCell align="center">Data Treinamento</TableCell>
                    <TableCell align="left">Instrutor</TableCell>
                    <TableCell align="center">Editar treinamento</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <Row key={row.id} row={row} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default BodyTraining;
